import React from "react";

import { useHistory } from "react-router-dom";

import { Button, NotificationSnackbar, StickyActionBar, Tabs } from "shared/ui";

import { MENU_ITEM_EDITOR_TABS } from "features/MenuItemEditor/constants";
import { MenuItemEditorContext } from "features/MenuItemEditor/context";
import { useActiveTab } from "features/MenuItemEditor/hooks/useActiveTab";
import { useMenuItemEditorState } from "features/MenuItemEditor/hooks/useMenuItemEditorState";
import { MenuItemEditorTab } from "features/MenuItemEditor/types";
import { ExtraTab } from "features/MenuItemEditor/components/tabs/ExtraTab";
import { MainTab } from "features/MenuItemEditor/components/tabs/MainTab";
import { ModifiersTab } from "features/MenuItemEditor/components/tabs/ModifiersTab";
import { PhotosTab } from "features/MenuItemEditor/components/tabs/PhotosTab";
import { ScheduleTab } from "features/MenuItemEditor/components/tabs/ScheduleTab";

import { ActionGroup, Container, Spacer, TabPanel } from "./styles";

const renderTab = (tab: MenuItemEditorTab) => {
    switch (tab) {
        case "main":
            return <MainTab />;
        case "photos":
            return <PhotosTab />;
        case "modifiers":
            return <ModifiersTab />;
        case "schedule":
            return <ScheduleTab />;
        case "extra":
            return <ExtraTab />;
    }
};

export const MenuItemEditor = () => {
    const history = useHistory();
    const [activeTab, setActiveTab] = useActiveTab();
    const state = useMenuItemEditorState();

    if (state.loading) {
        return <Container>Загрузка позиции…</Container>;
    }

    if (state.error) {
        return <Container>Не удалось загрузить позицию</Container>;
    }

    return (
        <MenuItemEditorContext.Provider value={state}>
            <Container>
                <Tabs
                    value={activeTab}
                    tabs={MENU_ITEM_EDITOR_TABS}
                    onChange={setActiveTab}
                />

                <TabPanel>{renderTab(activeTab)}</TabPanel>

                <StickyActionBar>
                    <Spacer />
                    <ActionGroup>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => history.goBack()}
                        >
                            Назад
                        </Button>
                        <Button
                            variant="contained"
                            disabled={state.saving}
                            onClick={state.save}
                        >
                            Сохранить
                        </Button>
                    </ActionGroup>
                </StickyActionBar>

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </MenuItemEditorContext.Provider>
    );
};
